import React, { FC } from 'react';
import { Direction } from 'types';
import { DirectionCard, DirectionCardTag, DirectionCardName, ArrowContainer } from './styled';
import { Icon } from 'kl-b2c-ui-kit';

interface DirectionBlockProps {
    item: Direction;
    isClosed: boolean;
    click: () => void;
    isMobileAccordion?: boolean;
}

const DirectionBlock: FC<DirectionBlockProps> = ({
    item: {
        name: descriptionName,
        type: { name: typeName },
        id,
    },
    click,
    isMobileAccordion,
}) => (
    <DirectionCard
        onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            click();
        }}
        data-at-selector={'directionContainer'}
        data-at-id={id}
        $isMobileAccordion={isMobileAccordion}
    >
        <DirectionCardTag data-at-selector={'directionTag'} $isMobileAccordion={isMobileAccordion}>
            {typeName}
        </DirectionCardTag>
        <DirectionCardName data-at-selector={'directionName'} $isMobileAccordion={isMobileAccordion}>
            {descriptionName}
        </DirectionCardName>
        <ArrowContainer>
            <Icon name={'ArrowShortRight'} color={'primary'} size={14} />
        </ArrowContainer>
    </DirectionCard>
);

export default DirectionBlock;
